/**
 * @file searchToggle
 *
 * @module search
 *
 */

import $ from 'jquery';

(function($) {
  'use strict';

  var config = {
    openBtn               : '.fpi-header-top-search button',
    searchWrapper         : '.fpi-searchForm-wrapper',
    closeBtn              : '.fpi-searchForm-closeBtn',
    class                 : 'is-opened',
  };

  /**
   * Extend the search object with functions responsible for the display behaviors
   * @memberof module:search
   */

  function searchToggle() {
    $(config.openBtn).on('click.searchToggle', function() {
      if (!$(config.searchWrapper).hasClass(config.class)) {
        $(config.searchWrapper).addClass(config.class);
      }
    });

    $(config.closeBtn).on('click.searchToggle', function(e) {
      e.preventDefault();
      if ($(config.searchWrapper).hasClass(config.class)) {
        $(config.searchWrapper).removeClass(config.class);
      }
    });
  }

  // init
  $(document).ready(function() {
    searchToggle();
  });

})($);



// WEBPACK FOOTER //
// ./src/js/searchToggle.js